/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'focus': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.602 12c-6.837 0-12.398 5.562-12.398 12.398 0 6.837 5.561 12.399 12.398 12.399C31.438 36.797 37 31.235 37 24.398 37 17.562 31.438 12 24.602 12zM25 33.771V28h-1v5.771C19 33.519 15.481 30 15.228 25H21v-1h-5.772C15.481 19 19 15.278 24 15.025V21h1v-5.975C30 15.278 33.722 19 33.975 24H28v1l5.969-.016c-.253 5-3.969 8.535-8.969 8.787z"/><path pid="1" d="M24 24h1v1h-1z" opacity=".5"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/focus.js